import RevisableLanguagePack from "../../../../../lib/html5-software-library/src/ranj/language/RevisableLanguagePack";
import AbstractMediator from "../../../core/ui/AbstractMediator";
import SkinKeyRegistry from "../../../core/ui/SkinKeyRegistry";
import { AbstractDialogPlayerMediator } from "../../../ngt/dialog/view/AbstractDialogPlayerMediators";
import KeyDecisionInteractionEvent from "../../key-decisions/event/KeyDecisionInteractionEvent";
import KeyDecisionAnswer from "../../key-decisions/model/KeyDecisionAnswer";
import ComposerEvent from "../event/ComposerEvent";
import ComposerTopicMediator from "./ComposerTopicMediator";

export default class ComposerScreenMediator extends AbstractDialogPlayerMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {RevisableLanguagePack} languagePack 
     */
    constructor(target, dispatcher, layoutManager, clickEaterFactory, languagePack, mediatorManager, contentPlayer) {
        super(target, dispatcher, layoutManager, clickEaterFactory);
        this._mediatorManager = mediatorManager;
        this._languagePack = languagePack;
        this._contentPlayer = this.getCustomData().contentPlayer;
        this._content = this.getCustomData().content;
        this._answers = [];
        this._optimalAnswers = [];
        this._titleTab1 = null;
        this._titleTab2 = null;
        this._tabsReady = [];
    }




    initialize() {
        super.initialize();

        this.preventClickThrough();

        const dialogPlayer = this.getCustomData().dialogPlayer;
        this.setDialogPlayer(dialogPlayer);

        this.registerEventListener(KeyDecisionInteractionEvent.CANCEL_KEY_DECISION, this._closeScreen.bind(this));
        this.registerEventListener(ComposerEvent.TAB_READY_TO_SUBMIT, this._tabReadyToSubmit.bind(this));
        this.registerEventListener(ComposerEvent.TAB_NOT_READY_TO_SUBMIT, this._tabNotReadyToSubmit.bind(this));

        this._target.Topic1.customData = {
            tabId: 1,
        };
        this._composerTopic1 = this._mediatorManager.createMediator(this._target.Topic1, SkinKeyRegistry.COMPOSER_TOPIC_SKIN);

        this._target.Topic2.customData = {
            tabId: 2,
        };
        this._composerTopic2 = this._mediatorManager.createMediator(this._target.Topic2, SkinKeyRegistry.COMPOSER_TOPIC_SKIN);

        this._handleTopic1ButtonBound = this._handleTopic1Button.bind(this);
        this._topic1Button = this.createButton(this._target.Topic1Button, this._handleTopic1ButtonBound);
        this._topic1Button.setSelected(true);
        this._topic1Button.setFocus(true);

        this._handleTopic2ButtonBound = this._handleTopic2Button.bind(this);
        this._topic2Button = this.createButton(this._target.Topic2Button, this._handleTopic2ButtonBound);

        this._handleSubmitButtonBound = this._handleSubmitButton.bind(this);
        this._submitButton = this.createButton(this._target.SubmitButton, this._handleSubmitButtonBound, this._languagePack.getText(`composer.mainScreen.buttonSubmit`));

        this._handleTopic1Button();

        // Disable Tab 2 by default
        this._topic2Button.target.alpha = 0;

        this._submitButton.setEnabled(false);
    }
    destroy() {
        super.destroy();

        this._composerTopic1.destroy();
        this._composerTopic2.destroy();
    }
    _closeScreen() {
        this.closeScreen(this._target);
    }

    _tabReadyToSubmit({ params: { tabId } }) {
        let index = this._tabsReady.indexOf(tabId)
        if (index == -1) {
            this._tabsReady.push(tabId);
        }

        if (this._topic2Button.target.alpha == 1) {
            if (this._tabsReady.length == 2) {
                this._submitButton.setEnabled(true);
            }
        } else if (this._tabsReady.length == 1) {
            this._submitButton.setEnabled(true);
        }
    }

    _tabNotReadyToSubmit({ params: { tabId } }) {
        let index = this._tabsReady.indexOf(tabId)
        if (index > -1) {
            this._tabsReady.splice(index, 1);
        }

        this._submitButton.setEnabled(false);
    }

    _handleTextContent(content) {
        if (this._titleTab1 == null) {
            this._titleTab1 = content.getText();
            this._topic1Button.setLabel(this._titleTab1);
        } else if (this._titleTab2 == null) {
            this._titleTab2 = content.getText();
            this._topic2Button.setLabel(this._titleTab2);
        } else if (!this._composerTopic1.hasDescription()) {
            this._composerTopic1.setDescription(content.getText());
        } else if (!this._composerTopic2.hasDescription()) {
            this._composerTopic2.setDescription(content.getText());
        }
    }

    _handleKeyMomentChoiceContent(content) {
        this._answers.push(content);
        if(KeyDecisionAnswer.GOOD_RATING == content.getSituationDescription()) {
            this._optimalAnswers.push(new KeyDecisionAnswer(content.getKeyMomentID(), content.getChoice(), content.getTip(), content.getSituationDescription()));
        }

        // Image is linked to the tab number
        var tabNumber = content.getImage();

        if (tabNumber == 1) {
            this._composerTopic1.addAnswer(content);
        } else if (tabNumber == 2) {
            this._topic2Button.target.alpha = 1;
            this._composerTopic2.addAnswer(content);
        }
    }

    _handleSubmitButton() {

        var playerAnswers = [];
        playerAnswers.push(...this._composerTopic1.getSelectedAnswers());
        playerAnswers.push(...this._composerTopic2.getSelectedAnswers());
        
        this._content.optimalAnswers = this._optimalAnswers;
        this._content.playerAnswers = playerAnswers;
        this._contentPlayer.contentCompleted(this._content);
        this._closeScreen();
    }

    _handleTopic1Button() {
        this.disableInteraction();
        this._topic2Button.setFocus(false);

        this._topic1Button.setSelected(true);
        this._topic2Button.setSelected(false);
        this._composerTopic2
            .hide()
            .then(_ => {
                this._composerTopic1.show()
            })
            .finally(_ => {
                this.enableInteraction();
            });


    }

    _handleTopic2Button() {
        this.disableInteraction();
        this._topic1Button.setFocus(false);

        this._topic1Button.setSelected(false);
        this._topic2Button.setSelected(true);
        this._composerTopic1
            .hide()
            .then(_ => {
                this._composerTopic2.show()
            })
            .finally(_ => {
                this.enableInteraction();
            });
    }
}